<template>
  <div class="bulk-submission-result">
    <Robin
      class="bulk-submission-result__robin"
      animation="backflip"
      :width="140"
      :height="120"
      :loop="false"
    />

    <Typography variant="h-4" class="text-center">
      Bulk Submission {{ bulkClaimSubmissionId }}: Thanks for your submission!
    </Typography>

    <Typography variant="subtitle-1" class="text-center mt-2">
      {{ successCount }} {{ successCount === 1 ? "claim" : "claims" }} successfully submitted.
      <span v-if="invalidCount > 0" class="red--text">
        remaining {{ invalidCount }} invalid {{ invalidCount === 1 ? "claim" : "claims" }} have been
        saved.</span
      >
      <span v-if="failedCount > 0">
        We ran into a problem with {{ failedCount }} {{ failedCount === 1 ? "claim" : "claims" }}.
        Please retry re-submitting these later.
      </span>
    </Typography>

    <div class="bulk-submission-result__buttons">
      <template v-if="hasRemainingInvalidOrFailed">
        <Button text @click="$emit('done')">I'm done for now</Button>
        <Button outlined @click="$emit('fix-invalid-claims')">Fix invalid claims</Button>
      </template>
      <Button v-else text @click="$emit('done')">Close</Button>
    </div>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import Robin from "@/components/Robin.vue";

export default {
  name: "BulkSubmissionResult",
  components: {
    Typography,
    Button,
    Robin,
  },
  props: {
    bulkClaimSubmissionId: {
      type: [String, Number],
      required: true,
    },
    successCount: {
      type: Number,
      required: true,
    },
    failedCount: {
      type: Number,
      required: true,
    },
    invalidCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    hasRemainingInvalidOrFailed() {
      return this.invalidCount > 0 || this.failedCount > 0;
    },
  },
};
</script>

<style scoped>
.bulk-submission-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  margin-top: 4rem;
  text-align: center;
}

.bulk-submission-result__robin {
  margin-bottom: 1rem;
}

.bulk-submission-result__buttons {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  margin-top: 2rem;
}
</style>
